import { useContext } from "react";

import { ComplexesContext } from "../contexts/ComplexesContext";

export const useComplexes = () => {
  return useContext(ComplexesContext);
};